module.exports = __webpack_public_path__ + "media/tr_tr_s4_Yusuf.fd6479c9.mp3";